import { render, staticRenderFns } from "./levels-description-placeholder.vue?vue&type=template&id=2ffe40f8&scoped=true&"
import script from "./levels-description-placeholder.vue?vue&type=script&lang=ts&"
export * from "./levels-description-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./levels-description-placeholder.vue?vue&type=style&index=0&id=2ffe40f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe40f8",
  null
  
)

export default component.exports